import { FlowStatus } from '../models/FlowStatus';
import Dexie, { Entity, EntityTable } from 'dexie';
import { LoggerService } from './LoggerService';

export class EctData extends Entity<EctDb> {
  orderId: string;
  redirectId: string;
  timestamp: Date;
  initialized: boolean;
  phoneNumber: string;
  refreshStarted: boolean;
  flowStatus: FlowStatus;
  idModelsPath: string;
  faceModelsPath: string;
  citizenship: string;
  finished: boolean;
}

export class EctDb extends Dexie {
  ectdata: EntityTable<EctData, 'orderId'>;

  constructor() {
    super('ectdb');
    this.version(1).stores({
      ectdata: 'orderId, redirectId, timestamp, initialized, phoneNumber, refreshStarted, flowStatus, idModelsPath, faceModelsPath, citizenship',
    });
    this.ectdata.mapToClass(EctData);
  }

  async getLastEctData(finished: boolean): Promise<EctData> {
    var allFinished = await this.ectdata.where({ finished: finished }).sortBy('timestamp');
    if (allFinished.length > 0) {
      return allFinished.reverse()[0];
    }
    return null;
  }

  public async getAllEctData(): Promise<EctData[]> {
    return await this.ectdata.toArray();
  }

  public async getOrCreateEctData(orderId: string): Promise<EctData> {
    var ectData = await this.ectdata.get(orderId);
    LoggerService.log('EctData found: ' + JSON.stringify(ectData));
    if (!ectData) {
      await this.ectdata.add({
        orderId: orderId,
        redirectId: '',
        timestamp: new Date(),
        initialized: false,
        finished: false,
        phoneNumber: '',
        refreshStarted: false,
        flowStatus: FlowStatus.NONE,
        idModelsPath: '',
        faceModelsPath: '',
        citizenship: '',
      });
      ectData = await this.ectdata.get(orderId);
      LoggerService.log('EctData set: ' + JSON.stringify(ectData));
    }
    return ectData;
  }
}
